var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTodo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    fill: "none",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffce48",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.66 335.21h94m-160.599.21 13.22 13.13 26.72-26.68m26.659-53.66h94m-160.599.21 13.22 13.13 26.72-26.68m26.659-53.16h94m-160.599.21 13.22 13.13 26.72-26.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.69 28.19H81.57v373.14h266.86V134.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.69 28.19v106.75h106.74"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodo);
export default __webpack_public_path__ + "static/media/todo.8301e2891ab8ecf04cb5674fa6776bfd.svg";
export { ForwardRef as ReactComponent };